import { Link } from "react-router-dom";

export const Footer = ({ categories = [] }) => (
  <footer className="mt-32 border-t border-bl-border bg-white" data-testid="site-footer">
    <div className="max-w-editorial mx-auto px-6 md:px-10 lg:px-14 py-16 md:py-20">
      <div className="grid md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <img
            src="/beckyliss-logo.png"
            alt="Beckyliss Cosmetics"
            className="h-20 md:h-24 w-auto object-contain mb-6"
            data-testid="footer-logo-img"
          />
          <p className="overline mb-4">Glossaire beauté</p>
          <h3 className="font-serif text-3xl md:text-4xl text-bl-text leading-tight max-w-md">
            Le glossaire beauté qui vous accompagne au cœur de chaque rituel.
          </h3>
          <p className="mt-6 text-sm text-bl-textSoft max-w-md leading-relaxed">
            Une encyclopédie vivante du soin et du maquillage, illustrée par les produits
            réels de la maison Beckyliss.
          </p>
        </div>
        <div className="md:col-span-4">
          <p className="overline mb-4">Familles</p>
          <ul className="grid grid-cols-2 gap-y-2 text-sm">
            {categories.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/categorie/${c.slug}`}
                  className="underline-grow text-bl-text"
                  data-testid={`footer-cat-${c.slug}`}
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="overline mb-4">Boutique</p>
          <a
            href="https://www.beckylisscosmetics.com/category/all-products"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm underline-grow text-bl-text block mb-2"
            data-testid="footer-shop-link"
          >
            Tous les produits Beckyliss
          </a>
          <a
            href="https://www.beckylisscosmetics.com"
            target="_blank"
            rel="noopener noreferrer"
            className="text-sm underline-grow text-bl-text block"
            data-testid="footer-home-link"
          >
            beckylisscosmetics.com
          </a>
        </div>
      </div>
      <div className="divider-rule mt-14" />
      <p className="mt-6 text-xs tracking-wide text-bl-textSoft">
        © {new Date().getFullYear()} Beckyliss Cosmetics. Tous droits réservés.
      </p>
    </div>
  </footer>
);
